import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PurchaseComponent } from './purchase/purchase.component';
import { PayConfirmationComponent } from './pay-confirmation/pay-confirmation.component';
import { PaymentComponent } from './payment/payment.component';



const routes: Routes = [
  {
    path: '',
    component: PurchaseComponent
  },
  {
    path: 'payment',
    component: PaymentComponent
    // data: { breadcrumb: 'TICKETS UPGRADE' }
  },
  {
    path: 'payConfirmation',
    component: PayConfirmationComponent
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
